<svelte:head>
    <title>The Phoenix Pages</title>
</svelte:head>

<div id="main" class="flex flex-col items-center justify-start flex-1 w-full max-h-full p-6 overflow-hidden">
    <iframe src="https://forms.izmichael.com/phoenix-pages-support" width="100%" height="100%" title="Typebot Form"/>
</div>
